import BaseViewController from "./base-view-controller";

class FinalScreenViewController extends BaseViewController {
  handleButtonClick() {
    this.appData.dependentStoredSuccess();
    this.appData.onExit();
  }
}

export default FinalScreenViewController;
